module.exports = __webpack_public_path__ + "static/media/nightowl-logo.99c1a82f.svg";